import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { Motion, spring } from 'react-motion';
import Controls from 'components/blottingPaper/Controls';

import imgCircle from './img/circle.svg';

import { withTranslation } from 'react-i18next'

const expectedResult = [20, 15, 7.5, 2];

class Predictions extends Component {

  render(){
    return(
      <div className="graphics">
        <h5 tabIndex={0}>{this.props.t("Estimate the size of each blot if you set the micropipette to:")}</h5>
        <ul>
          <li className="dropTarget">
            <p className="zone-label volume" aria-label={this.props.t("Blotting paper sample, demonstrating 10μl size.")}  tabIndex="0">10{this.props.t("μl")}</p>
            <div className="indicator">
              <img
                className="predictionSample"
                style={{ pointerEvents: "none", width: ((10 / this.props.solutions[0].maxVol) * 100)+"%" }}
                src={imgCircle}
                tabIndex={0}
                alt={
                  this.props.t(
                    "Blotting Paper sample, covering {{percentage}}% surface area",
                    {
                      percentage: Math.round((10 / this.props.solutions[0].maxVol) * 100)
                    }
                  )
                }
              />
            </div>
            <p className="zone-label index">{this.props.t("Sample")}</p>
          </li>
          {this.props.solutions.map((solution, index)=>(
            <li className="dropTarget"
                key={index}>
              <p className="zone-label volume" aria-label={this.props.t("Blotting paper position" + solution.id + ", predict " + expectedResult[index] + "μl size.")} tabIndex="0">{expectedResult[index]}{this.props.t("μl")}</p>
              <div className="indicator">
                <Controls id={this.props.id} index={index}/>
                <img
                  className={"prediction"+solution.id}
                  style={{ pointerEvents: "none", width: ((solution.prediction / solution.maxVol) * 100)+"%" }}
                  src={imgCircle}
                  tabIndex={0}
                  alt={
                    this.props.t(
                      'Blotting Paper position {{solution}}, covering {{percentage}}% surface area',
                      {
                        solution: solution.id,
                        percentage: Math.round((solution.prediction / this.props.solutions[0].maxVol) * 100).toFixed(2)
                      }
                    )
                  }
                  aria-live='assertive'
                />
              </div>
              <p className="zone-label index">{solution.id}</p>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        id: ownProps.id,
        solutions: state.blotPaper.blotPapers[ownProps.id-1].solutions,
        type: state.blotPaper.blotPapers[ownProps.id-1].type
    };
};

export default connect(mapStateToProps)(withTranslation()(Predictions));
